<!-- src/components/TableRow.vue -->

<template>
    <tr class="table-tr hover:bg-cal-EFEFEF bg-white cursor-pointer" v-bind:style="styles" >
        <td class="table-td px-4 py-2" v-if="multiselect" @click="$emit('checked-row', row)">
            <input
                type="checkbox"
                :checked="checked"
                @click.stop="$emit('checked-row', row)" />
        </td>
        <td is="table-cell"
            @click.native="selectedRow($event)"
            v-for="(column, index) in columns"
            v-bind:key="index"
            :class="index"
            :column="column"
            :index="index"
            :row="row">
        </td>
    </tr>
</template>

<script>

import TableCell from './VueTableCell.vue';

export default {

  components: {TableCell},

  computed: {
    styles: function () {
      if (!this.row.color) {
        return;
      }
      let hsl = this.hexToHsl(this.row.color);
      return {
        'background-color': `hsl(${hsl.h} ${hsl.s}% ${hsl.l}% / 15%)`,
      };
    }
  },
  props: {
    columns: null,
    row: null,
    multiselect: {
      default: false
    },
    checked: {
      default: false
    }
  },

    methods: {
        selectedRow (event) {
            this.$emit("selected-row", this.row, event);
        },
        hexToHsl (hex) {
          // modified version of https://gist.github.com/xenozauros/f6e185c8de2a04cdfecf.
          var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
          var r = parseInt(result[1], 16);
          var g = parseInt(result[2], 16);
          var b = parseInt(result[3], 16);

          r /= 255, g /= 255, b /= 255;

          var max = Math.max(r, g, b), min = Math.min(r, g, b);
          var h, s, l = (max + min) / 2;

          if (max == min) {
            h = s = 0; // achromatic
          } else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

            switch(max) {
              case r: h = (g - b) / d + (g < b ? 6 : 0); break;
              case g: h = (b - r) / d + 2; break;
              case b: h = (r - g) / d + 4; break;
            }

            h /= 6;
          }

          var hsl = new Object();
          hsl.h = Math.round(h * 360);
          hsl.s = Math.round(s * 100);
          hsl.l = Math.round(l * 100);

          return hsl;
        },
    }
}
</script>
